<div class="modal-dialog" #openModal>
  <div class="modal-content">
    <div class="modal-body text-center">
      <div class="modal-text">
        <!-- modalSetting.icon == 'success'?'assets/img/svg/success.svg': -->
        <!-- modalSetting.icon == 'error'?'assets/img/svg/error.svg': -->
        <p *ngIf="modalSetting.icon">
          <img [src]="
              modalSetting.icon == 'error'
                ? 'assets/img/modal-icon/error.png'
                : modalSetting.icon == 'success'
                ? 'assets/img/modal-icon/success.png'
                : modalSetting.icon == 'info'
                ? 'assets/img/modal-icon/info.png'
                : modalSetting.icon == 'warning'
                ? 'assets/img/modal-icon/alert.png'
                : modalSetting.icon == 'custom'
                ? modalSetting.img
                : 'assets/images/reset-password-img.png'
            " />
        </p>
        <h5 class="text-primary" *ngIf="modalSetting.title" [innerHTML]="modalSetting.title"></h5>

        <span class="text-primary" *ngIf="modalSetting.subtext" [innerHTML]="modalSetting.subtext"></span>
        <p class="mb-3 mt-3 text-primary" *ngIf="modalSetting.msg" [innerHTML]="modalSetting.msg"></p>
      </div>
      <div class="modal-btn mt-4">
        <button type="button" tabindex="0" *ngIf="modalSetting.btnAction" (click)="actionModal($event)"
          class="btn btn-outline-primary py-2 mx-1">
          {{ modalSetting.btnAction }}
        </button>
        <button type="button" tabindex="0" *ngIf="modalSetting.btnConfirm" (click)="confirmModal($event)"
          class="btn btn-outline-primary py-2 mx-1">
          {{ modalSetting.btnConfirm }}
        </button>
        <button type="button" tabindex="0" *ngIf="modalSetting.btnClose" (click)="closeModal($event)"
          class="btn btn-primary py-2 mx-1">
          {{ modalSetting.btnClose }}
        </button>
        <button type="button" tabindex="0" *ngIf="modalSetting.btnCancel" (click)="cancelModal($event)"
          class="btn btn-outline-primary py-2 mx-1">
          {{ modalSetting.btnCancel }}
        </button>
      </div>
    </div>
  </div>
</div>